import script from "./PayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPage.vue?vue&type=script&setup=true&lang=js"

import "./PayPage.vue?vue&type=style&index=0&id=71ef9e31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ef9e31"]])

export default __exports__